export default "__VITE_ASSET__8ebb1ba3__"